import React, { memo } from 'react'
import { Table, TableHead, TableBody, TableRow, TableCell } from 'transfix-ui'
import { ICostControlConfig } from '../types/costControlConfig'
import { CostControlConfigsTableRow } from './CostControlConfigsTableRow'

interface ICostControlConfigsTableProps {
  costControlConfigs: ICostControlConfig[]
  readOnly: boolean
}

const TABLE_COLUMNS = {
  quotingOrCovering: 'Quoting vs Covering',
  ruleType: 'Rule Type',
  ruleValue: 'Rule Value',
  costStrategy: 'Cost Strategy',
  dateRange: 'Date/Range',
  dropStatus: 'Is Drop',
}

export const CostControlConfigsTable = memo<ICostControlConfigsTableProps>(
  ({ costControlConfigs, readOnly }) => {
    if (costControlConfigs.length === 0) {
      return (
        <div className='tc mv2'>
          <h3>No cost control configs currently set</h3>
        </div>
      )
    }
    return (
      <Table fixed>
        <TableHead>
          <TableRow tableCellType='th'>
            {Object.entries(TABLE_COLUMNS).map(([key, value]) => (
              <TableCell
                tableCellType='th'
                dataTest={`${key}-column-header`}
                key={`${key}-column-header`}>
                <div className='rule-header'>{value}</div>
              </TableCell>
            ))}
            {!readOnly && (
              <TableCell
                className='tr'
                tableCellType='th'
                dataTest='action-column-header'
                key='action-column-header'>
                <div className='rule-header'>Actions</div>
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody dataTest='cost-control-configs-table'>
          {costControlConfigs.map(config => (
            <CostControlConfigsTableRow
              key={`${config.id}-cost-control-config`}
              costControlConfig={config}
              readOnly={readOnly}
            />
          ))}
        </TableBody>
      </Table>
    )
  }
)
